/**
 * Created by Bartosz.Pietrzyk on 2016-03-09.
 */
'use strict';
import { toolbox } from '../../externals/bss-package-toolbox/js/toolbox.js';
/**
 * BSSBackendConnector class
 */
var BSSBackendConnector = /** @class */ (function () {
    /**
     * BSSBackendConnector constructor
     * @param {Boolean} devMode if request should be replaced by 'GET' from mock data
     */
    function BSSBackendConnector(devMode) {
        if (devMode === void 0) { devMode = false; }
        this._devMode = devMode;
        /**
         * @type {Object}
         * @private
         * @desc stores configuration received from server
         */
        this._gaKEY = null;
        this._flowConfiguration = null;
        this._simulatorEnvironment = null;
    }
    /**
     * @desc request to server for default configuration
     * @param {String} typeOfRequest request type
     * @param {String} url
     * @param {Object} options - request option object
     * @param {String} entityInstanceId
     * @return {err, data}
     * @private
     */
    BSSBackendConnector.prototype._makeRequest = function (typeOfRequest, url, options, entityInstanceId) {
        var self = this;
        var headers = {
            'Cache-Control': 'no-cache, no-store',
            'X-Trace-Id': this.keyGenerator(),
        };
        if (this._simulatorEnvironment) {
            headers['x-bss-deployment-env'] = this._simulatorEnvironment;
        }
        if (!url) {
            var errObj = {
                entityInstanceId: entityInstanceId,
                errorMsg: 'BSSBackendConnector _makeRequest error: No URL for server request.',
            };
            this._errorHandler(null, errObj);
        }
        if (!options.params) {
            options.params = {};
        }
        this._checkIfPOSTisCorrectlyPrepared(options, typeOfRequest, headers);
        //add optional headers
        if (typeof options.headers === 'object') {
            Object.assign(headers, options.headers);
        }
        var forceEncodeURI = typeof options.forceEncodeURI !== 'undefined'
            ? !!options.forceEncodeURI
            : true;
        // ADD _ga KEY to all urls
        url = this._toUrl(url, { _ga: this._gaKEY }, forceEncodeURI);
        toolbox.$.ajax({
            url: url,
            type: typeOfRequest,
            data: options.params,
            dataType: 'json',
            headers: headers,
            contentType: 'application/json',
            error: function (err) {
                var errObj = {};
                switch (err.status) {
                    case 500:
                        errObj = self._checkRequestError(err, 'ERROR: Server side error');
                        break;
                    case 404:
                        errObj = self._checkRequestError(err, 'ERROR: Page not found');
                        break;
                    case 400:
                        errObj = self._checkRequestError(err, 'ERROR: Incorrect request');
                        break;
                    default:
                        errObj = self._checkRequestError(err, 'ERROR: Request error');
                }
                if (typeof options.callback === 'function') {
                    options.callback(errObj);
                }
            },
            success: function (data) {
                if (typeof options.callback === 'function') {
                    options.callback(null, data);
                }
            },
        });
    };
    BSSBackendConnector.prototype._checkIfPOSTisCorrectlyPrepared = function (options, typeOfRequest, headers) {
        var language;
        if (typeOfRequest.toLowerCase() === 'post') {
            if (typeof options.params === 'string') {
                language = JSON.parse(options.params).language;
            }
            else {
                language = options.params.language;
                options.params = JSON.stringify(options.params);
            }
            //add additional header to Italy request
            if (language === 'it') {
                headers['x-bss-market'] = 'italy';
            }
        }
    };
    /**
     * @desc request to server for default configuration
     * @param {String} typeOfRequest request type
     * @param {String} url
     * @param {Object} options - request option object
     * @param {String} entityInstanceId
     * @return {err, data}
     * @private
     */
    BSSBackendConnector.prototype._makeRequestUC = function (typeOfRequest, url, params, entityInstanceId, config) {
        if (config === void 0) { config = {}; }
        var headers = {
            'Cache-Control': 'no-cache, no-store',
            'X-Trace-Id': this.keyGenerator(),
        };
        if (this._simulatorEnvironment) {
            headers['x-bss-deployment-env'] = this._simulatorEnvironment;
        }
        if (!url) {
            var errObj = {
                entityInstanceId: entityInstanceId,
                errorMsg: 'BSSBackendConnector _makeRequest error: No URL for server request.',
            };
            this._errorHandler(null, errObj);
        }
        if (typeof params === 'undefined') {
            params = {};
        }
        //Check if POST are correct prepared.
        if (typeOfRequest.toLowerCase() === 'post' && typeof params !== 'string') {
            params = JSON.stringify(params);
        }
        var forceEncodeURI = typeof config.forceEncodeURI !== 'undefined'
            ? !!config.forceEncodeURI
            : true;
        // ADD _ga KEY to all urls
        url = this._toUrl(url, { _ga: this._gaKEY }, forceEncodeURI);
        return toolbox.$.ajax({
            url: url,
            type: this._devMode ? 'GET' : typeOfRequest,
            data: params,
            dataType: 'json',
            headers: headers,
            contentType: 'application/json',
        });
    };
    /**
     * @desc create error object based on response from the server
     * @param {Object} err - request error
     * @param {String} defaultMsg - default message for the error
     * @return {{status: *, code: string, msg: *}} errObj - error object for error handling mechanizm
     * @private
     */
    BSSBackendConnector.prototype._checkRequestError = function (err, defaultMsg) {
        var errResponse = err.responseText;
        var errObj = {
            status: err.status,
            code: '',
            msg: defaultMsg,
        };
        if (typeof errResponse !== 'undefined') {
            if (this._isJsonString(errResponse)) {
                var errResp = JSON.parse(errResponse);
                errObj.code = errResp.error_code;
                errObj.msg = errResp.message;
            }
            else {
                errObj.msg = errResponse;
            }
        }
        return errObj;
    };
    /**
     * @desc check weather given String can be parsed into JSON
     * @param {String} str - given string
     * @return {Boolean} - if true, can be parsed into JSON
     * @private
     */
    BSSBackendConnector.prototype._isJsonString = function (str) {
        try {
            JSON.parse(str);
        }
        catch (e) {
            return false;
        }
        return true;
    };
    /**
     * @desc Add query params to URL
     * @param baseUrl
     * @param params
     * @returns {string}
     * @private
     */
    BSSBackendConnector.prototype._toUrl = function (baseUrl, params, forceEncodeURI) {
        if (forceEncodeURI === void 0) { forceEncodeURI = true; }
        var url = baseUrl;
        var i = url.indexOf('?') === -1 ? 0 : 1;
        for (var k in params) {
            if (Object.hasOwn(params, k)) {
                if (i === 0) {
                    url += '?';
                }
                else {
                    url += '&';
                }
                url = url + k + '=' + params[k];
                i++;
            }
        }
        if (forceEncodeURI) {
            return encodeURI(url);
        }
        else {
            return url;
        }
    };
    /**
     * @desc return calculated offer from server
     * @param {String} url
     * @param {Object} params request parameters
     * @param {err - error, data - configuration data received from server} callback
     * @param {String} entityInstanceId
     * @public
     */
    BSSBackendConnector.prototype.getCalculatedOffer = function (url, params, callback, entityInstanceId) {
        var options;
        options = {};
        options.params = {};
        toolbox.$.extend(options.params, params);
        options.params = JSON.stringify(options.params);
        options.callback = callback;
        this._makeRequest(this._devMode ? 'GET' : 'POST', url, options, entityInstanceId);
    };
    /**
     * @desc return compare finance texts
     * @param {String} url
     * @param {err - error, data - configuration data received from server} callback
     * @param {String} entityInstanceId
     * @public
     */
    BSSBackendConnector.prototype.getCompareFinanceTexts = function (url, callback, entityInstanceId) {
        var options = {};
        options.callback = callback;
        this._makeRequest('GET', url, options, entityInstanceId);
    };
    /**
     * @desc return 'desired' data from server to be used for Lead Generation call on Italy market
     * @param {string} url
     * @param {{}} params request parameters
     * @param {function} callback request parameters
     * @param {number} entityInstanceId
     * @public
     */
    BSSBackendConnector.prototype.makeDataRequest = function (url, params, callback, entityInstanceId) {
        // To test locally:
        // Cors on client side won't allow to test locally with real API
        // Test server url, to test locally go to the 'server' folder and call $ npm start
        // url = `http://localhost:3100/desired`,
        var options;
        options = {};
        options.params = {};
        toolbox.$.extend(options.params, params);
        options.params = JSON.stringify(options.params);
        options.callback = callback;
        this._makeRequest('POST', url, options, entityInstanceId);
    };
    /**
     * @desc return configuration from server
     * @param {String} url
     * @param {err - error, data - configuration data received from server} callback
     * @param {Object} externalOptions
     * @param {String} entityInstanceId
     * @public method
     */
    BSSBackendConnector.prototype.getConfiguration = function (url, callback, externalOptions, entityInstanceId, method) {
        var self = this;
        var options = {
            callback: function (error, data) {
                if (error === null) {
                    self._flowConfiguration = data;
                }
                callback(error, data);
            },
            params: externalOptions,
        };
        var externalOptionsObj = typeof externalOptions === 'object'
            ? externalOptions
            : JSON.parse(externalOptions);
        if ('environment' in externalOptionsObj && // only simulator hasn't elementType
            (!('elementType' in externalOptionsObj) ||
                externalOptionsObj.elementType === 'productComparison' ||
                externalOptionsObj.elementType === 'usedCarsSimulator')) {
            // For simulator, UC and product comparison
            this._simulatorEnvironment = externalOptionsObj.environment;
        }
        if (this._flowConfiguration === null) {
            if (method && method === 'GET') {
                this._makeRequest('GET', url, options, entityInstanceId);
            }
            else {
                this._makeRequest(this._devMode ? 'GET' : 'POST', url, options, entityInstanceId);
            }
        }
        else {
            callback(null, this._flowConfiguration);
        }
    };
    /**
     * @dest get texts
     * @param {String} url
     * @param callback
     * @param {String} entityInstanceId
     * @public
     */
    BSSBackendConnector.prototype.getTexts = function (url, callback, entityInstanceId) {
        var options = {
            callback: function (error, data) {
                callback(error, data);
            },
        };
        this._makeRequest('GET', url, options, entityInstanceId);
    };
    /**
     * @desc Set GA key to BSSBackendConnector.
     * @param gaKEY
     * @public
     */
    BSSBackendConnector.prototype.setGAKey = function (gaKEY) {
        this._gaKEY = gaKEY;
    };
    /**
     * Generate unique keys.
     * @returns {string}
     * @constructor
     */
    BSSBackendConnector._S4 = function () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    /**
     * @desc Generate unique key example '85c79df8-0c67-01f7-07c4-85c79df8'.
     * @returns {string}
     * @public
     */
    BSSBackendConnector.keyGenerator = function () {
        return (this._S4() +
            this._S4() +
            '-' +
            this._S4() +
            '-' +
            this._S4() +
            '-' +
            this._S4() +
            '-' +
            Date.now().toString(16));
    };
    BSSBackendConnector.prototype.keyGenerator = function () {
        return BSSBackendConnector.keyGenerator();
    };
    return BSSBackendConnector;
}());
export { BSSBackendConnector };
